import { MatDialog } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { Injectable } from "@angular/core";
import { ConfirmationDialog } from "../components/confirmation-dialog/confirmation-dialog.component";

@Injectable({ providedIn: "root" })
export class ConfirmService {

  constructor(private dialog: MatDialog) {

  }
  public isConfirmed(data?): Observable<boolean> {
    const dialogRef = this.dialog.open(ConfirmationDialog,{data});
    return dialogRef.afterClosed();
  }
  get open(): Observable<boolean> {
    return this.isConfirmed()
  }
  
}
